module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-en1.9ea7cce.png";